export default "static/media/sleepstop.661b4b5.svg"